import React from 'react'
import "./pageBlog.css";

import HeaderBlog3 from "../pageBlog/HeaderBlog3";
 import BodyBlog3 from "../pageBlog/BodyBlog3";
import Footer2 from "../footer2/Footer2";

function PageBlog3() {
  return (
    <section>
      
       <HeaderBlog3/>
       <BodyBlog3/>
       <Footer2/>
    </section>
  )
}

export default PageBlog3